import React from 'react';
import './styles/artikelsektion.css';
import CTAKnap, { CTAIkoner } from './ctaknap';

const ArtikelSektion = () => {
  const articles = [
    {
      id: 9,
      title: "SEO og AI-søgninger i 2026: Den Komplette Guide",
      excerpt: "AI-søgemaskiner som ChatGPT og Google SGE ændrer fundamentalt måden vi søger på. Lær hvordan du tilpasser din SEO-strategi til fremtidens AI-drevne søgeoplevelser.",
      readTime: "15 min",
      category: "SEO & AI",
      slug: "seoogaii2026",
      publishDate: "2026-01-12",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=400&fit=crop",
      keywords: ["SEO 2026", "AI-søgninger", "Google SGE", "ChatGPT søgning", "semantisk SEO", "nulklik søgninger"]
    },
    {
      id: 5,
      title: "Verden Med AI - Hvordan Kunstig Intelligens Påvirker Din Online Tilstedeværelse",
      excerpt: "Kunstig intelligens har stiltiende revolutioneret internettet. Discover hvordan AI påvirker alt fra søgeresultater til hjemmeside-design, og lær hvad det betyder for din online succes i 2025.",
      readTime: "12 min",
      category: "AI & Digital",
      slug: "verden-med-ai",
      publishDate: "2025-09-25",
      image: require('../images/media/Verden-med-AI.png'),
      keywords: ["AI kunstig intelligens", "hjemmeside AI", "online tilstedeværelse", "digital transformation"]
    },
    {
      id: 1,
      title: "Den Komplette SEO Guide 2025 - Alt Du Skal Vide",
      excerpt: "Fra keyword research til link building - denne omfattende guide dækker alt hvad du behøver for at dominere Google's søgeresultater.",
      readTime: "15 min",
      category: "SEO Guide",
      slug: "seo-guide-2025",
      publishDate: "2025-01-21",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2015&q=80",
      keywords: ["SEO guide", "søgemaskineoptimering", "SEO 2025", "keyword research"]
    },
    {
      id: 2,
      title: "Hvad koster en hjemmeside i 2025? - Komplet prisguide",
      excerpt: "Få det fulde overblik over hvad en hjemmeside koster. Fra simple websites til komplekse webshops - læs vores detaljerede prisguide og få tips til at spare penge.",
      readTime: "12 min",
      category: "Prisguide",
      slug: "hvad-koster-hjemmesider",
      publishDate: "2025-09-02",
      image: require('../images/showcase/CBS-PC.webp'),
      keywords: ["hjemmeside pris", "hvad koster hjemmeside", "website pris", "webdesign pris"]
    },
    {
      id: 3,
      title: "Webdesign Trends 2025: Fremtidens Hjemmesider",
      excerpt: "Discover de hotteste webdesign trends for 2025. Fra minimalistisk design til mobile-first approach - lær hvordan du skaber moderne hjemmesider der konverterer.",
      readTime: "10 min",
      category: "Webdesign",
      slug: "webdesign-trends-2025",
      publishDate: "2025-09-03",
      image: require('../images/showcase/byggeriets-pc.webp'),
      keywords: ["webdesign trends", "moderne hjemmesider", "UX design", "mobile first", "design trends"]
    },
    {
      id: 4,
      title: "10 Største Webdesign Fejl Virksomheder Laver (Og Hvordan Du Undgår Dem)",
      excerpt: "Undgå de mest almindelige webdesign fejl der koster virksomheder kunder. Lær hvordan dårlig brugervenlighed, langsom hastighed og forvirende navigation skader din online succes.",
      readTime: "8 min",
      category: "Webdesign Guide",
      slug: "webdesign-fejl-virksomheder-laver",
      publishDate: "2025-09-04",
      image: require('../images/media/webdesign-fejl.png'),
      keywords: ["webdesign fejl", "hjemmeside fejl", "brugervenlighed", "UX fejl", "mobilvenlig design"]
    },
    {
      id: 6,
      title: "Mobilvenlige Hjemmesider: Hvorfor Din Virksomhed SKAL Være Mobile-First i 2025",
      excerpt: "Over 65% af al web-trafik kommer nu fra mobile enheder. Hvis din hjemmeside ikke er optimeret til mobil, mister du bogstaveligt talt kunder hver dag.",
      readTime: "15 min",
      category: "Mobile & UX",
      slug: "mobilvenlige-hjemmesider",
      publishDate: "2025-09-30",
      image: "https://images.unsplash.com/photo-1556075798-4825dfaaf498?w=800&h=400&fit=crop",
      keywords: ["mobilvenlige hjemmesider", "responsive design", "mobile-first", "UX", "Google mobile"]
    },
    {
      id: 7,
      title: "Designsystemer: Fundamentet for Skalerbart og Professionelt Webdesign",
      excerpt: "Lær hvordan designsystemer skaber sammenhæng, forbedrer effektiviteten og sikrer professionel kvalitet på tværs af hele din digitale tilstedeværelse.",
      readTime: "12 min",
      category: "Design Guide",
      slug: "designsystemer",
      publishDate: "2025-10-20",
      image: "https://images.unsplash.com/photo-1558655146-d09347e92766?w=800&h=400&fit=crop",
      keywords: ["designsystemer", "design tokens", "komponentbibliotek", "UI design", "design guide"]
    },
    {
      id: 8,
      title: "Hvordan Google Indekserer Din Hjemmeside - Den Komplette Guide",
      excerpt: "Forstå den fascinerende proces bag hvordan Google finder, crawler, render og indekserer din hjemmeside. Lær alt fra crawling til ranking og optimer din side til bedre synlighed.",
      readTime: "10 min",
      category: "SEO Guide",
      slug: "google-indeksering",
      publishDate: "2025-11-04",
      image: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?ixlib=rb-4.0.3&auto=format&fit=crop&w=2069&q=80",
      keywords: ["google indeksering", "crawler", "googlebot", "seo crawling", "website indeksering", "søgemaskine"]
    }
  ];

  // Sort articles by publish date (newest first) and take only the 3 most recent
  const sortedArticles = articles
    .sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate))
    .slice(0, 3);

  const ArticleCard = ({ article }) => (
    <article 
      className="article-card"
      itemScope
      itemType="https://schema.org/Article"
    >
      <div className="article-image">
        {article.image ? (
          <img 
            src={article.image} 
            alt={article.title}
            className="article-image-img"
            itemProp="image"
          />
        ) : (
          <div className="image-placeholder">
            <div className="placeholder-icon">📖</div>
            <div className="placeholder-text">{article.category}</div>
          </div>
        )}
        <div className="article-category">
          {article.category}
        </div>
      </div>
      
      <div className="article-content">
        <div className="article-meta">
          <time 
            dateTime={article.publishDate}
            itemProp="datePublished"
            className="article-date"
          >
            {new Date(article.publishDate).toLocaleDateString('da-DK', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </time>
          <span className="article-read-time">
            {article.readTime} læsning
          </span>
        </div>
        
                <h3 className="article-title" itemProp="headline">
          <a 
            href={`/artikler/${article.slug}`} 
            itemProp="url"
            className="article-link"
          >
            {article.title}
          </a>
        </h3>
        
        <p className="article-excerpt" itemProp="description">
          {article.excerpt}
        </p>
        
        <div className="article-footer">
          <CTAKnap 
            variant="text" 
            size="small"
            href={`/artikler/${article.slug}`}
            icon={<CTAIkoner.ArrowRight />}
            aria-label={`Læs artiklen: ${article.title}`}
          >
            Læs mere
          </CTAKnap>
        </div>
      </div>
      
      {/* Hidden structured data */}
      <div style={{display: 'none'}}>
        <span itemProp="author" itemScope itemType="https://schema.org/Organization">
          <span itemProp="name">Parla Branding</span>
        </span>
        <span itemProp="publisher" itemScope itemType="https://schema.org/Organization">
          <span itemProp="name">Parla Branding</span>
          <span itemProp="logo" itemScope itemType="https://schema.org/ImageObject">
            <span itemProp="url">https://www.parlabranding.dk/logo.jpg</span>
          </span>
        </span>
        <span itemProp="dateModified">{article.publishDate}</span>
      </div>
    </article>
  );

  return (
    <section className="artikelsektion" id="blog" aria-labelledby="articles-heading">
      <div className="container">
        <div className="artikelsektion-header">
          <h2 id="articles-heading" className="artikelsektion-title">
            Læs vores ekspertguides
          </h2>
          <p className="artikelsektion-subtitle">
            Få værdifulde tips og tricks til at forbedre din hjemmeside og SEO-performance
          </p>
        </div>

        <div className="artikelsektion-grid">
          {sortedArticles.map(article => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="artikelsektion-cta">
          <CTAKnap 
            variant="primary" 
            size="large"
            href="/artikler"
            icon={<CTAIkoner.FileText />}
          >
            Se alle artikler
          </CTAKnap>
          <CTAKnap 
            variant="outline" 
            size="large"
            href="/tjenester"
            icon={<CTAIkoner.Search />}
          >
            Se vores tjenester
          </CTAKnap>
        </div>

      </div>
      
      {/* Structured Data for Blog Section */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Blog",
          "name": "Parla Branding Blog",
          "description": "Ekspertguides til SEO, webdesign og digital marketing",
          "url": "https://www.parlabranding.dk/blog",
          "publisher": {
            "@type": "Organization",
            "name": "Parla Branding",
            "logo": "https://www.parlabranding.dk/logo.jpg"
          },
          "blogPost": sortedArticles.map(article => ({
            "@type": "BlogPosting",
            "headline": article.title,
            "description": article.excerpt,
            "datePublished": article.publishDate,
            "dateModified": article.publishDate,
            "author": {
              "@type": "Organization",
              "name": "Parla Branding"
            },
                           "publisher": {
                 "@type": "Organization",
                 "name": "Parla Branding",
                 "logo": "https://www.parlabranding.dk/logo.jpg"
               },
                         "url": `https://www.parlabranding.dk/blog/${article.slug}`,
             "image": `https://www.parlabranding.dk${article.image}`,
            "keywords": article.keywords.join(", ")
          }))
        })}
      </script>
    </section>
  );
};

export default ArtikelSektion;
